<template>
  <div class="login-container">
    <v-row class="fill-height ma-0">
      <!-- Left Side - Logo Section -->
      <v-col
        cols="12"
        md="6"
        class="logo-section d-flex align-center justify-center pa-8"
      >
        <div class="logo-content text-center">
          <v-img
            src="../../public/img/apitab-color.png"
            max-width="350px"
            height="auto"
            contain
            class="mx-auto logo-shadow mb-6"
          >
          </v-img>

          <p class="welcome-subtitle grey--text text--darken-1">
            Administra tus operaciones portuarias de manera eficiente
          </p>
        </div>
      </v-col>

      <!-- Right Side - Login Form -->
      <v-col cols="12" md="6" class="form-section d-flex flex-column pa-0">
        <div class="form-wrapper d-flex flex-column justify-center flex-grow-1 pa-8">
          <div class="form-content mx-auto">
            <div class="form-header mb-6">
              <h1 class="text-h4 font-weight-bold primary--text mb-2">Iniciar sesión</h1>
              <p class="text-subtitle-1 grey--text text--darken-1">
                Ingresa tus credenciales para continuar
              </p>
            </div>

            <v-form @submit.prevent="ingresar" class="login-form">
              <v-text-field
                v-model="email"
                type="email"
                autofocus
                color="primary"
                label="Correo electrónico"
                prepend-inner-icon="email"
                outlined
                dense
                class="mb-3"
                required
              ></v-text-field>

              <v-text-field
                v-model="password"
                :type="show1 ? 'text' : 'password'"
                color="primary"
                label="Contraseña"
                prepend-inner-icon="lock"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                @click:append="show1 = !show1"
                outlined
                dense
                class="mb-4"
                required
              ></v-text-field>

              <v-btn
                type="submit"
                block
                :loading="loading"
                color="primary"
                class="white--text font-weight-bold login-btn mb-3"
                large
                elevation="2"
              >
                <v-icon left>login</v-icon>
                Ingresar
              </v-btn>

              <div class="text-center mb-4">
                <v-btn
                  text
                  small
                  color="secondary"
                  @click="forgotPassword"
                  class="text-none"
                >
                  ¿Olvidaste tu contraseña?
                </v-btn>
              </div>
            </v-form>
          </div>
        </div>

        <!-- Scanner Button - Compact -->
        <div class="d-flex justify-center pa-4">
          <v-btn
            color="secondary"
            outlined
            small
            @click="showQrInfoDialog"
            class="scanner-btn"
          >
            <v-icon small left>qr_code_scanner</v-icon>
            Escanear QR
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="qrInfoDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">Información</v-card-title>
        <v-card-text>
          <div class="d-flex justify-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
              v-if="loading_camera"
            ></v-progress-circular>
          </div>
          <qrcode-stream
            @decode="onDecode"
            v-if="mostrarCamara"
            :camera="camera"
            @init="onInit"
          >
          </qrcode-stream>

          <div v-if="info.modelo">
            <v-card-subtitle v-if="info.data.counter"
              >Acceso de vehiculos personal : VP-000{{
                info.data.counter
              }}</v-card-subtitle
            >
            <v-card-subtitle v-if="info.data.folio"
              >Solicitud de acceso a personal : CG-000{{
                info.data.folio
              }}</v-card-subtitle
            >
            <v-card-subtitle v-if="info.data.folio_solicitud && info.modelo !== 'CNA'"
              >Solicitud de acceso unica : SU-000{{
                info.data.folio_solicitud
              }}</v-card-subtitle
            >
            <v-card-subtitle v-if="info.modelo === 'CNA'">
              Certificado de No Adeudo :
              <span v-if="info.data.tipo === 'Liquidado'">
                APITAB-OP-F-{{ info.data.folio_cna }}-CNA
              </span>
              <span v-else>
                <span v-if="info.data.pagado">
                  APITAB-OP-F-{{ info.data.folio_cna }}-CNA-B
                </span>
                <span v-else> APITAB-OP-F-{{ info.data.folio_cna }}-CNA-A </span>
              </span>
            </v-card-subtitle>
            <v-divider></v-divider>

            <v-card-text v-if="info.modelo === 'CNA'">
              <v-alert type="success" dense outlined class="mb-3">
                <strong>✓ Datos válidos</strong> - Este CNA es auténtico y verificado.
              </v-alert>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Agencia</v-list-item-title>
                    <v-list-item-subtitle>{{
                      info.data.folio_solicitud.agencia.nombre
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Embarcación</v-list-item-title>
                    <v-list-item-subtitle>{{
                      info.data.folio_solicitud.embarcacion.nombre
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Tipo</v-list-item-title>
                    <v-list-item-subtitle>{{ info.data.tipo }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Tipo de Carga</v-list-item-title>
                    <v-list-item-subtitle>{{
                      info.data.tipo_carga
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Puerto Destino</v-list-item-title>
                    <v-list-item-subtitle>{{
                      info.data.puerto_destino
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Total Toneladas</v-list-item-title>
                    <v-list-item-subtitle
                      >{{ info.data.total_ton }} TON</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>

            <v-card-text v-else>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Agencia</v-list-item-title>
                    <v-list-item-subtitle>{{
                      info.data.agencia.nombre
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Embarcación</v-list-item-title>
                    <v-list-item-subtitle>{{
                      info.data.embarcacion.nombre
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-card-subtitle class="">Autorizaciones</v-card-subtitle>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title style="font-weight: bold">
                      {{ info.data.autorizacion_1.nombre_completo }}</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      <strong>Correo:</strong> {{ info.data.autorizacion_1.correo }}
                      <br />
                      <strong>Fecha de Aprobación:</strong>
                      {{ info.data.autorizacion_1.fecha_aprobacion }} <br />
                      <strong>Autorizado:</strong>
                      <v-icon v-if="info.data.autorizacion_1.autorizado" color="green"
                        >check</v-icon
                      >
                      <v-icon v-else color="red">cancel</v-icon>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title style="font-weight: bold">
                      {{ info.data.autorizacion_2.nombre_completo }}</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      <strong>Correo:</strong> {{ info.data.autorizacion_2.correo }}
                      <br />
                      <strong>Fecha de Aprobación:</strong>
                      {{ info.data.autorizacion_2.fecha_aprobacion }} <br />
                      <strong>Autorizado:</strong>
                      <v-icon v-if="info.data.autorizacion_2.autorizado" color="green"
                        >check</v-icon
                      >
                      <v-icon v-else color="red">cancel</v-icon>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeQrInfoDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";

export default {
  components: {
    QrcodeStream,
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      dialog: false,
      errorM: "",
      snackbar: false,
      show1: false,
      mostrarCamara: false,
      camera: "auto",
      loading_camera: false,
      showScanConfirmation: false,
      qrInfoDialog: false,
      empresa: "",
      info: [],
      nombre: "",
      direccion: "",
      rol: "",
      cargo: "",
      telefono: "",
      estado: "",
    };
  },
  methods: {
    // Proceso de autenticación principal con redirección condicional según rol
    ingresar() {
      this.loading = true;

      axios
        .post("usuario/login", {
          email: this.email.trim(), // Limpia espacios en email
          password: this.password.trim(), // Limpia espacios en contraseña
        })
        .then((respuesta) => {
          return respuesta.data; // Extrae datos de respuesta
        })
        .then((data) => {
          // Almacena token de autenticación en store global
          this.$store.dispatch("guardarToken", data.tokenReturn);

          // Lógica de redirección condicional basada en rol de usuario
          if (data.user.rol == "Vigilante") {
            // Vigilantes van directamente a gestión de acceso
            this.$router.push({ name: "gestion_acceso" });
          } else {
            // Otros roles van al dashboard principal
            this.$router.push({ name: "home" });
          }
        })
        .catch((error) => {
          this.errorM = null;
          // Manejo específico de errores de autenticación
          if (error.response.status == 404) {
            this.$notify({
              title: "Error!",
              text: "El usuario no existe, favor de verificar sus datos",
              type: "error",
            });
          } else {
            this.errorM = "Ocurrio un error con el servidor";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Registro de nuevos usuarios PSP (Prestadores de Servicios Portuarios)
    guardar() {
      let me = this;
      // Creación de cuenta PSP con estado pendiente de aprobación
      axios
        .post("usuario/addPsp", {
          nombre: this.nombre,
          rol: "PSP", // Rol específico para prestadores de servicios portuarios
          estado: 0, // Estado pendiente de aprobación por administrador
          empresa: this.empresa, // Empresa del PSP
          email: this.email,
          direccion: this.direccion,
          telefono: this.telefono,
          password: this.password,
          cargo: this.cargo, // Cargo dentro de la empresa
        })
        .then(function (response) {
          // Confirmación de registro exitoso con instrucciones adicionales
          swal(
            "Datos agregados con exito",
            "Para que tu solicitud sea aprobada favor de enviar por correo los siguientes archivos:",
            "success"
          );
          me.close();
          me.limpiar();
        })
        .catch(function (error) {
          me.close();
          me.limpiar();
          swal("Error", "Verique los datos ingreasados" + error, "error");
        });
    },
    forgotPassword() {
      this.$router.push({ name: "forgot_password" });
    },
    // Inicia escaner QR para validación de documentos portuarios
    showQrInfoDialog() {
      this.info = []; // Limpia información previa
      this.qrInfoDialog = true; // Abre modal de scanner
      this.mostrarCamara = true; // Activa cámara
    },
    // Cierra scanner y desactiva cámara
    closeQrInfoDialog() {
      this.qrInfoDialog = false;
      this.mostrarCamara = false;
    },
    limpiar() {
      (this.nombre = ""),
        (this.email = ""),
        (this.empresa = ""),
        (this.cargo = ""),
        (this.telefono = ""),
        (this.direccion = ""),
        (this.contraseña = "");
    },
    close() {
      this.dialog = false;
    },
    // Inicialización de la cámara para escaneo QR con manejo de errores
    async onInit(promise) {
      try {
        this.loading_camera = true;
        await promise; // Espera inicialización de cámara
      } catch (e) {
        console.error(e); // Log de errores de cámara
      } finally {
        this.loading_camera = false;
        // Muestra confirmación visual cuando cámara está desactivada
        this.showScanConfirmation = this.camera === "off";
      }
    },

    // Procesa código QR escaneado y obtiene información del documento
    async onDecode(content) {
      this.result = content; // ID del documento escaneado
      this.getDataQr(content); // Valida y obtiene datos del documento
      this.mostrarCamara = false; // Desactiva cámara tras escaneo exitoso
    },

    // Valida y obtiene información detallada del documento portuario escaneado
    async getDataQr(_id) {
      this.loading_camera = true;
      await axios
        .get("solicitudUnica/validar_qr/" + _id)
        .then((e) => {
          console.log(e.data);
          this.info = e.data; // Almacena información del documento validado
          // Incluye: CNA, solicitudes de acceso, autorizaciones, datos de embarcaciones
        })
        .catch((err) => {
          console.log(err);
          // Manejo de QR inválidos o documentos no encontrados
        })
        .finally(() => {
          this.loading_camera = false;
        });
    },
  },
};
</script>
<style scoped>
.login-container {
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
}

/* Left Side - Logo Section */
.logo-section {
  background: #f5f5f5;
  height: 100vh;
}

.logo-content {
  max-width: 500px;
}

.logo-shadow {
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

.logo-shadow:hover {
  transform: scale(1.02);
}

.welcome-title {
  font-size: 2rem;
  line-height: 1.2;
}

.welcome-subtitle {
  font-size: 1.1rem;
  line-height: 1.5;
  max-width: 400px;
  margin: 0 auto;
}

/* Right Side - Form Section */
.form-section {
  background: #ffffff;
  height: 100vh;
}

.form-wrapper {
  width: 100%;
}

.form-content {
  width: 100%;
  max-width: 450px;
}

.form-header h1 {
  line-height: 1.2;
}

.login-form {
  width: 100%;
}

.scanner-section {
  flex-shrink: 0;
  background: #f9f9f9;
  border-top: 1px solid #e0e0e0;
}

.scanner-btn {
  height: 32px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  border-radius: 6px !important;
  padding: 0 12px !important;
}

.scanner-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.v-text-field {
  transition: all 0.3s ease;
}

.v-text-field:hover {
  transform: translateY(-1px);
}

.login-btn {
  height: 48px !important;
  font-size: 16px !important;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.headline {
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 960px) {
  .logo-section {
    height: 30vh !important;
    padding: 24px !important;
    order: 1;
    background: #fafafa;
  }

  .form-section {
    height: 70vh !important;
    padding: 24px !important;
    order: 2;
  }

  .logo-shadow {
    max-width: 200px !important;
    margin-bottom: 16px !important;
  }

  .welcome-title {
    font-size: 1.4rem !important;
    margin-bottom: 8px !important;
  }

  .welcome-subtitle {
    font-size: 0.95rem !important;
  }

  .form-header {
    margin-bottom: 20px !important;
  }

  .form-header h1 {
    font-size: 1.8rem !important;
  }

  .form-header p {
    font-size: 0.9rem !important;
  }

  .scanner-section {
    margin-top: 16px !important;
  }
}

@media (max-width: 600px) {
  .logo-section,
  .form-section {
    padding: 16px !important;
  }

  .logo-shadow {
    max-width: 160px !important;
  }

  .welcome-title {
    font-size: 1.2rem !important;
  }

  .welcome-subtitle {
    font-size: 0.85rem !important;
  }

  .form-header h1 {
    font-size: 1.5rem !important;
  }

  .form-header p {
    font-size: 0.8rem !important;
  }

  .form-content {
    max-width: 100%;
  }

  .scanner-section {
    margin-top: 12px !important;
  }

  .scanner-btn {
    height: 40px !important;
    font-size: 12px !important;
  }
}

/* Smooth transitions */
* {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
</style>
